import { useEffect, useState } from "react";
import GuardianReview from "../../Components/GuardianReview";

const GuardianReviewPage = () => {

  return (
    <>
        <GuardianReview />
    </>
  );
};

export default GuardianReviewPage;
